import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetPaymentAssistance: IMcAppType = {
  name: "internetPaymentAssistance",
  path: "/my/internet/payment-assistance",
  description: "Internet Payment Assistance",
  parameters: {
    properties: {
      accountNumber: CommonParameters.superloopAccountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Payment assistance",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "internetPaymentAssistance",
    customerType: CustomerType.kraken,
  },
};
